export const SET_APP_BUSY = 'SET_APP_BUSY'

/**
 * Set app busy
 * @param {Object} state
 * @param {boolean} busy
 * @return {Object}
 */
function setAppBusy(state, busy) {
    return {
        ...state,
        busy: busy,
    }
}

/**
 * Reducer for error object in store
 * @param {Object} state
 * @param {Object} action
 * @returns {*|{error: *, message: *}|Array}
 */
export default function reducer(state = [], action) {
    switch(action.type) {
        case SET_APP_BUSY: return setAppBusy(state, action.busy)
        default: return state
    }
}
